module.exports = __webpack_public_path__ + "static/9-c31f7002e62125faccbb21416c858dcd.jpg";